module.exports = "/_next/static/images/b2a22c30c12558f7cc69102b82273ee5-lock.svg";